/* projects/speaker-platform/src/app/atoms/status-badge/status-badge.component.scss */
.statusbadge {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
}
.statusbadge--small {
  width: 12px;
  height: 12px;
  border-width: 2px;
}
.statusbadge--SEANCE {
  background-color: #99FF74;
}
.statusbadge--ABSENCE {
  background-color: #FFC107;
}
.statusbadge--MALADE {
  background-color: #FF7474;
}
.statusbadge--STUDIO {
  background-color: #74E4FD;
}
.statusbadge--NO_SEANCE,
.statusbadge--PUBLIC_HOLIDAYS {
  background-color: #ADADAD;
}
/*# sourceMappingURL=status-badge.component-MQFEVHNF.css.map */
